import React, { useContext, useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import { formatNumberWithComma } from "features/helpers/utils";
import NoDataComponent from "features/metadesk/CommunityAnalysis/components/chart/NoDataComponent";
import { isEmpty } from "lodash-es";
import Percent from "components/Percent/Percent";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
import { useIntl } from "react-intl";

export default function PieChart({ chartData }) {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const sumTotal = chartData?.dataArray?.reduce(
    (acc, item) => acc + item.value,
    0
  );

  const getOptions = (newSeries) => {
    return {
      tooltip: {
        trigger: "item",
      },
      legend: {
        show: false,
      },
      series: chartData?.seriesData,
    };
  };

  const renderRateBox = (item) => {
    let color, icon;

    if (item.rate === "-") {
      return null;
    }

    if (formatNumberWithComma(item.rate) == 0) {
      color = theme.customColors.grey[500];
      icon = null;
    } else if (item.rate > 0) {
      color = theme.customColors.green[500];
      icon = <i className="meta-crm-icon-ic_up font-size-12" />;
    } else {
      color = theme.customColors.pink[500];
      icon = <i className="meta-crm-icon-ic_down font-size-12" />;
    }

    return (
      <Box
        sx={{
          color: color,
          marginLeft: "auto",
        }}>
        {icon}
        {formatNumberWithComma(Math.abs(item.rate))}%
      </Box>
    );
  };

  return isEmpty(chartData.seriesData) || sumTotal === 0 ? (
    <EmptyIconStatus
      icon="pie"
      emptyTitle={formatMessage({ id: "emptyState.pieChart.title" })}
      emptyDescription={formatMessage({
        id: "emptyState.pieChart.description",
      })}
    />
  ) : (
    <>
      {chartData?.dataArray?.map((item, index) => (
        <Box display={"flex"} mb={2} key={index}>
          <Box mb="2px" mr="5px">
            {item.icon}
          </Box>
          <Box>
            <Box mb="4px" color={theme.customColors.grey[600]}>
              {item.name}
            </Box>
            <Box display={"flex"} alignItems={"center"}>
              <Box
                sx={{
                  fontSize: "18px",
                  color: theme.customColors.grey[700],
                  marginRight: "8px",
                }}>
                {formatNumberWithComma(item.value)}
              </Box>
              <Percent
                data={item?.rate === "-" ? "-" : item?.rate?.toFixed(2)}
              />
            </Box>
          </Box>
        </Box>
      ))}

      <ReactECharts
        option={getOptions()}
        autoResize={true}
        style={{ height: "100%" }}
        notMerge={true}
      />
    </>
  );
}
